import { Input, type InputRef } from 'antd';
import type { InputProps, SearchProps, TextAreaProps } from 'antd/es/input';
import type { InputSemanticAllType } from 'antd/es/input/Input';
import type { InputSearchSemanticType } from 'antd/es/input/Search';
import type { TextAreaRef, TextAreaSemanticAllType } from 'antd/es/input/TextArea';
import clx from 'classnames';
import React from 'react';

type InputSearchProps = Omit<SearchProps, 'classNames'> & {
    classNames?: InputSearchSemanticType['classNames'];
}

const InputSearch = React.forwardRef<InputRef, InputSearchProps>(({ classNames, ...props }, ref) => (
  <Input.Search
    ref={ref}
    {...props}
    suffix={<i className="fb-icon--search" />}
    classNames={{
      ...classNames,
      button: { ...(classNames?.button ?? {}), root: clx(classNames?.button?.root, 'd-none') },
    }}
  />
));

type FBTextAreaProps = Omit<TextAreaProps, 'classNames'> & {
    classNames?: TextAreaSemanticAllType['classNames'];
}

const FBTextArea = React.forwardRef<TextAreaRef, FBTextAreaProps>(
  (props, ref) => <Input.TextArea ref={ref} {...props} />,
);

type FBInputComponent = React.ForwardRefExoticComponent<InputProps & React.RefAttributes<InputRef>> & {
  TextArea: typeof FBTextArea;
  Search: typeof InputSearch;
  Password: typeof Input.Password;
};

type FBInputProps = Omit<InputProps, 'classNames'> & {
    classNames?: InputSemanticAllType['classNames'];
}

const FBInput = React.forwardRef<InputRef, FBInputProps>(
  (props, ref) => <Input ref={ref} {...props} />,
) as FBInputComponent;

FBInput.TextArea = FBTextArea;

FBInput.Search = InputSearch;

FBInput.Password = Input.Password;

export default FBInput;
